/** @flow */
import React, { Component } from 'react';
import styled, { withTheme } from 'styled-components';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { translate } from 'react-i18next';

import Radio from 'common/domain/radio';
import Page from 'common/components/Page';
import { openSnackbar } from 'common/modules/ui/actions/uiActions';
import PropositionDetailsContent from 'common/modules/proposition/components/PropositionDetailsContent';
import FixedActionsBar from 'common/components/FixedActionsBar';
import LoadingSpinner from 'common/components/LoadingSpinner';
import Proposition from 'common/modules/proposition/domain/proposition';
import PrintButton from 'advertisers/components/PrintButton';
import Location from 'common/helpers/location';
import PrintingService from 'common/services/PrintingService';

import { getToken } from 'statsradio/modules/authentication/session/selectors/sessionSelectors';
import SalesPropositionApi from 'statsradio/modules/sales/services/SalesPropositionApi';
import PropositionDetailsActions from './components/proposition/PropositionDetailsActions';

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const PropositionDetailsContentStyled = styled(PropositionDetailsContent)`
  margin-bottom: 60px;
`;

type Props = {
  token: string,
  currentRadio: Radio,

  actions: {
    openSnackbar: (string, string) => any,
  },

  t: any,
  theme: any,
  match: Object,
  history: any,
}

type State = {
  proposition?: Proposition,
  isFetching: boolean,
}

class SalesPropositionDetailPage extends Component<Props, State> {

  state = { proposition: undefined, isFetching: false };

  componentWillMount() {
    const { currentRadio, token, actions, t } = this.props;
    const reference = this.props.match.params.reference;

    this.setState({ isFetching: true });
    SalesPropositionApi.fetchSalesProposition(currentRadio.callSign, token, reference)
      .then(proposition => this.setState({ proposition, isFetching: false }))
      .catch(() => {
        this.setState({ isFetching: false });
        actions.openSnackbar('error', t('couldNotLoadSaleProposal'));
      });
  }

  componentWillReceiveProps(nextProps: Props) {
    if (this.props.currentRadio !== nextProps.currentRadio) {
      this.props.history.replace('/propositions');
    }
  }

  onPrintSales = () => {
    const { proposition } = this.state;
    const { currentRadio } = this.props;
    const dateRange = proposition && proposition.dateRange;
    const estimation = proposition && proposition.estimation;

    const url = Location.buildUrlFor('proposition-printing');
    const message = {
      estimation: estimation ? estimation.toJSON() : '',
      radio: currentRadio.toJSON(),
      dateRange: dateRange ? dateRange.toISO() : '',
    };

    PrintingService.printWindowWithData(url, 'SALES_DATA', message);
  };

  render() {
    const { proposition, isFetching } = this.state;
    const { theme, t } = this.props;

    const title = (proposition && proposition.title) || t('propositions');
    return (
      <Page title={title} hideTitle>
        {isFetching &&
        <LoadingSpinner size="medium" />
        }
        {!isFetching && !proposition &&
        <span style={theme.fonts.style.smallCardTitle}>
            {t('noDataAvailable')}
          </span>
        }
        {!isFetching && proposition &&
        <div style={{ paddingTop: theme.metrics.margin }}>
          <PropositionDetailsContentStyled proposition={proposition} />
          <FixedActionsBar position="BOTTOM">
            <PrintButton onClick={this.onPrintSales} />
            <ButtonWrapper>
              <PropositionDetailsActions
                onChange={modified => this.setState({ proposition: modified })}
                proposition={proposition}
              />
            </ButtonWrapper>
          </FixedActionsBar>
        </div>
        }
      </Page>
    );
  }
}

function mapStateToProps(state) {
  return {
    token: getToken(state),
    currentRadio: state.session.radio,
  };
}

function mapDispatchToProps(dispatch: *) {
  return {
    actions: bindActionCreators({ openSnackbar }, dispatch),
  };
}

export default translate('commonSales')(connect(mapStateToProps, mapDispatchToProps)(withTheme(withRouter(SalesPropositionDetailPage))));



// WEBPACK FOOTER //
// ./src/statsradio/modules/sales/SalesPropositionDetailPage.js